import React, {Component} from "react";
import {withRouter} from "react-router-dom";
import {
  convertFromTranslationObject,
  parseUrlQuery,
} from "../../../../05-utils/commonUtils";
import "./style.css";
import {loadProducts} from "../../../../01-actions/adminProducts";
import {loadCategories} from "../../../../01-actions/adminCategories";
import {connect} from "react-redux";
import {getEnv} from "../../../../env";
import ProductItem from "../../../../03-components/ProductItem";
import TranslationViewer from "../../../../03-components/TranslationViewer";
import ProductPanel from "../../../../03-components/ProductPanel/index";
import {withLocalize} from "react-localize-redux";
import {Translate} from "react-localize-redux";
import {Input, Pagination, PaginationItem, PaginationLink} from "reactstrap";

const RESULT_PER_PAGES = [5, 10, 20, 50];
const MAX_PAGI = 5;

class ProductsPage extends Component {
  constructor(props) {
    super(props);
    props.loadAllCategories();
    props.loadAllProducts();
    this.state = {
      currentPage: 0,
      resultPerPage: RESULT_PER_PAGES[0],
    };
  }

  render() {
    const queries = parseUrlQuery(this.props.location.search);
    //-- filter products
    const keyword = queries.keyword;
    const category =
      queries.categoryId &&
      this.props.categories.find((c) => c._id === queries.categoryId);
    let products = keyword
      ? this.props.products.filter((p) => {
          return (
            p.name.indexOf(keyword) >= 0 ||
            (p.description &&
              convertFromTranslationObject(p.description).indexOf(keyword) >= 0)
          );
        })
      : this.props.products.filter(
          (p) => !queries.categoryId || p.categoryId === queries.categoryId,
        );
    const productDetails = queries.id
      ? this.props.products.find((p) => p._id === queries.id)
      : null;

    let productDetailCategory = null;
    if (productDetails) {
      productDetailCategory = this.props.categories.find(
        (c) => c._id === productDetails.categoryId,
      );
    }

    let numberOfPages = Math.round(products.length / this.state.resultPerPage);

    let arPages = [];
    for (
      let i = Math.trunc(this.state.currentPage / MAX_PAGI) * MAX_PAGI;
      i <
      Math.min(
        numberOfPages,
        (Math.trunc(this.state.currentPage / MAX_PAGI) + 1) * MAX_PAGI,
      );
      i++
    ) {
      arPages.push(i);
    }

    products = products
      .slice(
        this.state.currentPage * this.state.resultPerPage,
        (this.state.currentPage + 1) * this.state.resultPerPage,
      )
      .sort((p1, p2) => p1.order - p2.order);

    return (
      <div className="container-home-products flex-grow-1">
        <ProductPanel
          className="margin-left-15px margin-right-15px"
          title={
            <div className="d-flex justify-content-between align-items-center">
              {category ? (
                <div className={"d-flex"}>
                  <TranslationViewer value={category.name} />
                  {productDetails && (
                    <div>&nbsp;-&nbsp;{productDetails.name}</div>
                  )}
                </div>
              ) : (
                this.props.translate(keyword ? "search_result" : "all_products")
              )}
              <div className="d-flex align-items-center">
                <div className="margin-right-15px">
                  <Translate id="showing" />
                </div>
                <Input
                  className="pagi-select"
                  type="select"
                  value={this.state.resultPerPage}
                  onChange={(e) => {
                    this.setState({resultPerPage: e.target.value});
                  }}
                >
                  {RESULT_PER_PAGES.map((value) => (
                    <option key={value}>{value}</option>
                  ))}
                </Input>
              </div>
            </div>
          }
        >
          <div className="flex-grow-1 product-list">
            {productDetails && productDetailCategory && (
              <div className="product-detail">
                <div className="d-flex flex-column justify-content-between">
                  <div className="d-flex flex-row">
                    <div className="info">
                      <div className="img-wrapper">
                        <img
                          className="img1"
                          src={
                            getEnv("S3_ASSETS_BUCKET") +
                            "/" +
                            productDetails.img1
                          }
                          alt="img1"
                        />
                      </div>
                      <div className="detail d-flex flex-column flex-grow-1 justify-content-start">
                        <div className="category-name">
                          <TranslationViewer
                            value={productDetailCategory.name}
                          />
                        </div>
                        <div className="product-name">
                          {productDetails.name}
                        </div>
                        {productDetails.description && (
                          <div className="text-justify product-description">
                            <TranslationViewer
                              value={productDetails.description}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="more-detail">
                    <Translate id="more_details" />
                  </div>
                  <div className="img2-wrapper">
                    {productDetails.img2 && (
                      <img
                        className="img2"
                        src={
                          getEnv("S3_ASSETS_BUCKET") + "/" + productDetails.img2
                        }
                        alt="img2"
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
            {!productDetails && products && !products.length && (
              <div className="no-product">
                <Translate id="no_product_found" />
              </div>
            )}
            {!productDetails && (
              <div>
                <div>
                  {products &&
                    products.length > 0 &&
                    products.map((p, index) => (
                      <ProductItem
                        key={index}
                        id={p._id}
                        categoryId={p.categoryId}
                        category={
                          this.props.categories.find(
                            (c) => c._id === p.categoryId,
                          ).name
                        }
                        name={p.name}
                        img={getEnv("S3_ASSETS_BUCKET") + "/" + p.img1}
                      />
                    ))}
                </div>
                <div className="d-flex justify-content-center margin-top-20px">
                  <Pagination aria-label="Page navigation example">
                    <PaginationItem
                      onClick={() => {
                        if (this.state.currentPage > 0)
                          this.setState({
                            currentPage: this.state.currentPage - 1,
                          });
                      }}
                    >
                      <PaginationLink previous />
                    </PaginationItem>
                    {Math.trunc(this.state.currentPage / MAX_PAGI) * MAX_PAGI >
                      0 && (
                      <PaginationItem
                        onClick={() => {
                          this.setState({
                            currentPage: Math.max(
                              0,
                              this.state.currentPage - MAX_PAGI,
                            ),
                          });
                        }}
                      >
                        <PaginationLink>...</PaginationLink>
                      </PaginationItem>
                    )}
                    {arPages.map((value) => (
                      <PaginationItem
                        active={this.state.currentPage === value}
                        onClick={() => {
                          this.setState({currentPage: value});
                        }}
                        key={value}
                      >
                        <PaginationLink>{value + 1}</PaginationLink>
                      </PaginationItem>
                    ))}
                    {(Math.trunc(this.state.currentPage / MAX_PAGI) + 1) *
                      MAX_PAGI <
                      numberOfPages && (
                      <PaginationItem
                        onClick={() => {
                          this.setState({
                            currentPage: Math.min(
                              numberOfPages - 1,
                              this.state.currentPage + MAX_PAGI,
                            ),
                          });
                        }}
                      >
                        <PaginationLink>...</PaginationLink>
                      </PaginationItem>
                    )}
                    <PaginationItem
                      onClick={() => {
                        if (this.state.currentPage < numberOfPages - 1)
                          this.setState({
                            currentPage: this.state.currentPage + 1,
                          });
                      }}
                    >
                      <PaginationLink next />
                    </PaginationItem>
                  </Pagination>
                </div>
              </div>
            )}
          </div>
        </ProductPanel>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    products: store.adminProducts.products,
    categories: store.adminCategories.categories,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadAllCategories: () => {
      dispatch(loadCategories());
    },
    loadAllProducts: () => {
      dispatch(loadProducts({}));
    },
  };
};

export default withRouter(
  withLocalize(connect(mapStateToProps, mapDispatchToProps)(ProductsPage)),
);



// WEBPACK FOOTER //
// ./src/04-containers/_pages/Home/Products/index.js